//TODO: determine if this is obsolete

!function(root, factory){

    factory(root, root.app, root.overwatch);

}(this, function(root, app, overwatch){

    var util = overwatch.util;
    var $grid = $('.news-panels');

    $grid.find('.grid-item.youtube').on('click', 'a', function(event){
        var id = $(this).attr('data-id');
        if(loadVideoIntoLightbox(id)) {
            event.preventDefault();
        }
    });

    $(document.body).on("click", "[data-js=youtube-lightbox]", function(event) {
        var id = $(this).data('id') || $(this).data('yt-id');
        if(loadVideoIntoLightbox(id)) {
            event.preventDefault();
        }
    });

    var loadVideoIntoLightbox = function(id) {
        if(!util.mobile() && !util.touch()){
            app.helpers.loadVideoIntoFrame(id);
            return true;
        }
        return false;
    }

});
